export { VpPluginsTable } from './VpPluginsTable';



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginsTable/index.js